import { useSession } from "next-auth/react";

export function useDemo() {
  const { data: session } = useSession();
  const isDemo = session?.user?.role === "DEMO";
  const demoGender = session?.user?.gender as string | undefined;
  const personaName = demoGender === "male" ? "Aryan" : "Priya";
  return { isDemo, demoGender, personaName };
}
